class Settings {
    data = {};

    language = undefined;

    changeLanguage(language) {
        this.language = language;
    }

    async load(url) {
        try {
            const response = await fetch(url, {
                headers: new Headers({ 'cache-control': 'no-cache', pragma: 'no-cache' }),
            });
            const data = [200, 400].includes(response.status) ? await response.json() : {};
            this.parse(data);
        } catch (error) {
            console.error(error);
            throw new Error('Error al cargar configuración.', { cause: error });
        }
    }

    parse(data) {
        this.app = data.app;
        this.zones = data.zones;
        this.languages = data.languages;
        this.internalBrands = data.internalBrands;
        this.maxProductSelection = data.maxProductSelection;
        this.internalProfileEmailDomains = data.internalProfileEmailDomains;
        const languageData = {};
        data.languages.forEach((language) => {
            languageData[language.value] = {};
            Object.keys(data[language.value]).forEach((key) => {
                if (key === 'choices') {
                    languageData[language.value].choices = this.buildChoices(data[language.value][key]);
                    languageData[language.value].enums = this.buildEnums(data[language.value][key]);
                } else {
                    languageData[language.value][key] = data[language.value][key];
                }
            });
        });
        this.data = languageData;
    }

    buildChoices(data = {}) {
        return Object.keys(data).reduce(
            (choices, key) => ({
                ...choices,
                [key]: [...data[key]],
            }),
            {}
        );
    }

    buildEnums(data = {}) {
        return Object.keys(data).reduce(
            (enums, key) => ({
                ...enums,
                [key]: data?.[key]?.reduce((indexed, item, index) => {
                    const object = { ...item, order: index };
                    // Index by identifier and value, if they're the same 'value' wins
                    return {
                        ...indexed,
                        [item.identifier]: object,
                        [item.value]: object,
                    };
                }, {}),
            }),
            {}
        );
    }
}

const settings = new Settings();

export default new Proxy(settings, {
    get: (target, prop) => {
        const whitelist = [
            'app',
            'load',
            'parse',
            'zones',
            'languages',
            'internalBrands',
            'changeLanguage',
            'maxProductSelection',
            'internalProfileEmailDomains',
            'buildChoices',
            'buildEnums',
        ];
        if (whitelist.includes(prop)) return target[prop];
        return target.data[target.language][prop];
    },
});

export const isExpertoBayer = () => settings.app.theme === 'expertobayer';
